import { COLORS } from '@xox/shared'
import { SHIRT_FILL } from '../../lib/flair'

const PIECES = 24

/**
 * One-shot confetti burst in the shirt palette. Pure CSS animation, so the global
 * reduced-motion rule turns it into a static sprinkle.
 */
export function Confetti() {
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden rounded-2xl motion-reduce:hidden"
      aria-hidden
    >
      {Array.from({ length: PIECES }, (_, i) => {
        const color = COLORS[i % COLORS.length]!
        const left = (i * 37) % 100
        const delay = (i % 6) * 0.12
        const size = 6 + (i % 3) * 3
        return (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: pieces are purely positional
            key={i}
            className="absolute top-0 animate-confetti rounded-sm"
            style={{
              left: `${left}%`,
              width: size,
              height: size * 0.6,
              background: SHIRT_FILL[color],
              animationDelay: `${delay}s`,
            }}
          />
        )
      })}
    </div>
  )
}
